import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

if (typeof window === 'object') {
    const smoothScroll = require('smoothscroll-polyfill');
    smoothScroll.polyfill();
}
